import './style.scss';
import './editor.scss';
import Swiper from 'swiper/bundle';

document.addEventListener( 'DOMContentLoaded', function () {
	const hasBlockTeam = document.querySelector( '.block__team' );
	if ( hasBlockTeam ) {
		/*
		 *	 This move the modals to before </body>
		 */
		const moveModals = document.querySelectorAll( '.block__team .modal' );
		if ( moveModals ) {
			moveModals.forEach( ( moveModal ) => {
				document.querySelector( 'body' ).append( moveModal );
			} );
		}

		/*
		 *	 Filter Actions on Layout Filter
		 */

		const filterItems = document.querySelectorAll( '.filterTeam__item' );
		if ( filterItems ) {
			filterItems.forEach( ( filterItem ) => {
				filterItem.addEventListener( 'click', ( event ) => {
					const active = document.querySelector(
						'.filterTeam .active'
					);
					active.classList.remove( 'active' );
					event.target.classList.add( 'active' );
					const filter = event.target.getAttribute( 'data-filter' );
					filterSelection( filter );
				} );
			} );
		}

		filterSelection( 'all' );

		function filterSelection( c ) {
			var x, i;
			x = document.getElementsByClassName( 'col-card' );
			if ( c == 'all' ) c = '';
			for ( i = 0; i < x.length; i++ ) {
				w3RemoveClass( x[ i ], 'show' );
				if ( x[ i ].className.indexOf( c ) > -1 )
					w3AddClass( x[ i ], 'show' );
			}
		}

		function w3AddClass( element, name ) {
			var i, arr1, arr2;
			arr1 = element.className.split( ' ' );
			arr2 = name.split( ' ' );
			for ( i = 0; i < arr2.length; i++ ) {
				if ( arr1.indexOf( arr2[ i ] ) == -1 ) {
					element.className += ' ' + arr2[ i ];
				}
			}
		}

		function w3RemoveClass( element, name ) {
			var i, arr1, arr2;
			arr1 = element.className.split( ' ' );
			arr2 = name.split( ' ' );
			for ( i = 0; i < arr2.length; i++ ) {
				while ( arr1.indexOf( arr2[ i ] ) > -1 ) {
					arr1.splice( arr1.indexOf( arr2[ i ] ), 1 );
				}
			}
			element.className = arr1.join( ' ' );
		}

		// import Swiper JS
		const carousels = document.querySelectorAll( '.swiper__teams' );
		if ( carousels ) {
			carousels.forEach( ( carousel ) => {
				const id = carousel.id;
				if ( id ) {
					const nextButton = carousel.querySelector(
						'.swiper-button-next'
					);
					const prevButton = carousel.querySelector(
						'.swiper-button-prev'
					);
					const paginator =
						carousel.querySelector( '.swiper-pagination' );
					const perViewSlider =
						carousel.getAttribute( 'data-perview' );

					const swiperCarousel = new Swiper( `#${ id }`, {
						centeredSlides: false,
						grabCursor: true,
						spaceBetween: 30,
						slideToClickedSlide: true,

						// Rotation
						autoplay: {
							delay: 7000,
							disableOnInteraction: false,
						},

						// Navigation arrows
						navigation: {
							nextEl: nextButton,
							prevEl: prevButton,
						},

						pagination: {
							el: paginator,
							clickable: true,
						},

						// Responsive breakpoints

						breakpoints: {
							320: {
								slidesPerView: 1,
							},
							576: {
								slidesPerView: 1,
							},
							768: {
								slidesPerView: 2,
							},
							992: {
								slidesPerView: perViewSlider,
							},
						},
					} );

					swiperCarousel.autoplay.stop();

					const playPauseButton = carousel.querySelector(
						'.swiper-button-play-pause'
					);

					playPauseButton.addEventListener( 'click', function ( e ) {
						const arialLabel =
							playPauseButton.getAttribute( 'aria-label' );
						if ( arialLabel == 'play' ) {
							swiperCarousel.autoplay.start();
							playPauseButton.setAttribute(
								'aria-label',
								'pause'
							);
						} else {
							swiperCarousel.autoplay.pause();
							playPauseButton.setAttribute(
								'aria-label',
								'play'
							);
						}
					} );
				}
			} );
		}
	}
} );
